import React from 'react';
import {BrowserRouter as Router, Routes, Route, Link} from 'react-router-dom';
import BurgerMenu from './Components/BurgerMenu';

import './styles/NavigationBar.css';

import Home from './Home';
import About from './About';
import Location from './Location';
import Bilder from './Bilder';

import Admin from './Admin/Admin';
import AdminLogin from './Admin/AdminLogin';
import AdminBilder from './Admin/AdminBilder';

import logo from "./assets/dsj_logo.png"
import Anmeldung from './Anmeldung';
import AnmeldungSucess from './AnmeldungSucess';
import AnmeldungFail from './AnmeldungFail';
import Impressum from './Impressum';
import Datenschutz from './Datenschutz'

import './styles/global.css'
import '@fontsource/amatic-sc';

function App() {
  return (
    <Router id="outer-container">
      <div className='NavContainer'>
        <Link to="/">
          <img className='Logo' src={logo} alt="Logo"/>
        </Link>
        <h1 className='PageHeader'>ZELTLAGER DER SCHREBERJUGEND SÜD-WEST</h1>
        <BurgerMenu/>
      </div>
      <div className='ShadowContainer'/>
      
      

      <Routes id="page-wrap">
        <Route path='/datenschutz' element={<Datenschutz/>}/>
        <Route path='/impressum' element={<Impressum/>}/>
        <Route path="/anmeldung" element={<Anmeldung/>}/>
        <Route path="/anmeldung/success" element={<AnmeldungSucess/>}/>
        <Route path="/anmeldung/fail" element={<AnmeldungFail/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/" element={<Home/>}/>
        <Route path="/location" element={<Location/>}/>
        <Route path='/bilder' element={<Bilder/>}/>

        <Route path='/admin' element={<Admin/>}/>
        <Route path='/admin/login' element={<AdminLogin/>}/>
        <Route path='/admin/bilder' element={<AdminBilder/>}/>
      </Routes>
    </Router>
  );
}

export default App;
